import { ParcelSizes, ParcelSizesFormValues } from "../financial.types";

export const getUpdateParcelSizesRequestBody = (
  parcelSizes: ParcelSizesFormValues
): ParcelSizes => {
  return {
    s: {
      minVolume: Number(parcelSizes.s.minVolume),
      maxVolume: Number(parcelSizes.s.maxVolume),
      minWeight: Number(parcelSizes.s.minWeight),
      maxWeight: Number(parcelSizes.s.maxWeight)
    },
    m: {
      minVolume: Number(parcelSizes.m.minVolume),
      maxVolume: Number(parcelSizes.m.maxVolume),
      minWeight: Number(parcelSizes.m.minWeight),
      maxWeight: Number(parcelSizes.m.maxWeight)
    },
    l: {
      minVolume: Number(parcelSizes.l.minVolume),
      maxVolume: Number(parcelSizes.l.maxVolume),
      minWeight: Number(parcelSizes.l.minWeight),
      maxWeight: Number(parcelSizes.l.maxWeight)
    }
  };
};
